import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextual", "children", "centered", "ModalDialog", "onCloseComplete", "onCloseStart", "onEsc", "onOpenComplete", "onOpenStart", "rootNode", "size", "use"];
import { forwardRef } from 'react';
import AbstractModal from '../AbstractModal/AbstractModal';
import { ModalTransition } from './ModalTransition';
import { DisplayOptimizedProvider, PanelContext } from '../../context';
import { jsx as _jsx } from "react/jsx-runtime";
export const Modal = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      contextual,
      children,
      centered,
      ModalDialog,
      onCloseComplete,
      onCloseStart,
      onEsc,
      onOpenComplete,
      onOpenStart,
      rootNode,
      size,
      use
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  /**
   * PanelContext is only consumed by DialogFooter.
   * If DialogFooter is in a Modal which is a child of Panel,
   * the value of inPanel used by DialogFooter to set the background color
   * should be set to false to prevent a gray background color.
   */
  return /*#__PURE__*/_jsx(PanelContext.Provider, {
    value: {
      inPanel: false,
      inModal: true
    },
    children: /*#__PURE__*/_jsx(DisplayOptimizedProvider, {
      value: false,
      children: /*#__PURE__*/_jsx(AbstractModal, Object.assign({}, rest, {
        ModalDialog: ModalDialog,
        onOpenStart: onOpenStart,
        onOpenComplete: onOpenComplete,
        onCloseStart: onCloseStart,
        onCloseComplete: onCloseComplete,
        rootNode: rootNode,
        onEsc: onEsc,
        use: use,
        size: size,
        centered: centered,
        _contextual: contextual,
        componentName: "Modal",
        Transition: ModalTransition,
        ref: ref,
        children: children
      }))
    })
  });
});